document.addEventListener('DOMContentLoaded', function() {
  const atcBtn = document.querySelector('.product-form__submit');
  if (!atcBtn) return;

  const sticky = document.createElement('div');
  sticky.className = 'sticky-atc';
  sticky.innerHTML = `
    <span class="sticky-atc__title">${document.querySelector('.product__title')?.textContent || ''}</span>
    <button class="sticky-atc__btn" onclick="document.querySelector('.product-form__submit').click()">Læg i indkøbskurv</button>
  `;
  document.body.appendChild(sticky);

  const observer = new IntersectionObserver(([entry]) => {
    sticky.classList.toggle('visible', !entry.isIntersecting);
  });
  observer.observe(atcBtn);
});
